import styled, { css } from 'styled-components';
import { colors, monokaiBackground, monokaiBackgroundOffset } from 'global/colors';

export const SelectorContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const SelectorHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TabList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  column-gap: 5px;
`;

export const TabItem = styled.div`
  user-select: none;
  padding: 0.5rem 0.8rem;
  ${({ isDarkMode }) => {
    return css`
      background-color: ${isDarkMode ? monokaiBackgroundOffset : colors.white};
      border: 1px ${isDarkMode ? monokaiBackground : colors.borderGray};
    `;
  }}
  position: relative;
  color: ${colors.gray2} !important;
  border-style: solid solid none solid;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  cursor: pointer;
  text-align: center;
  ${({ active }) =>
    active &&
    css`
      z-index: 1;
      ${({ isDarkMode }) => {
        return css`
          color: ${isDarkMode ? colors.fsCyan : colors.fsDarkBlue}!important;
          background-color: ${isDarkMode ? monokaiBackground : colors.white};
          border-bottom: 1px solid ${isDarkMode ? monokaiBackground : colors.white};
        `;
      }}
      font-weight: 600;
      // Cover the border from TabList and off-set the height difference
      margin-top: -1px;
      top: 1px;
    `}
`;

export const ActiveArea = styled.div`
  ${({ isDarkMode }) => {
    return css`
      border-top: 1px solid ${isDarkMode ? monokaiBackground : colors.borderGray};
      background-color: ${isDarkMode ? monokaiBackground : colors.white};
    `;
  }}
  ${({ headerHeight }) => css`
    height: calc(100% - ${headerHeight}px);
  `}
`;

export const TabIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  cursor: pointer;
  margin-right: 5px;
  font-size: 1rem;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      color: ${colors.fsCyan};
    `}
`;

// Container that can be used in other components for extra header options
export const OptionContainer = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  column-gap: 15px;
  row-gap: 5px;
`;
